// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/ausbildungsstart-2022-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const ausbildungsstart20222DE: PageEntry = {
  id: "post.ausbildungsstart-2022-2",
  locale: "de",
  slug: "ausbildungsstart-2022-2",
  seo: {
    title: "Ausbildungsstart 2022 | Dietz GmbH",
    description: "Ausbildungsstart 2022",
  },
  type: "post",
  h1: "Ausbildungsstart 2022",
  blocks: [
    { kind: "heading", level: 2, text: "Ausbildungsstart 2022" },
    { kind: "paragraph", text: "Heute starten insgesamt 7 neue Auszubildende im gewerblichen und kaufmännischen Bereich ihre Ausbildung bei uns." },
    { kind: "paragraph", text: "Die gesamte Dietz-Familie wünscht allen Durchstartern eine ereignisreiche, spannende und informative erste Woche – wir freuen uns auf die gemeinsame Zukunft mit euch!" }
  ],
};
